module.exports = __webpack_public_path__ + "static/assets/b832cde706fd52f8f8745c6b1d744c7a.svg";